let REGISTERED_PLUGINS = []

class LauncherPlugin {
  constructor({
    app, Launcher, ops,
  }, plugin) {
    if (REGISTERED_PLUGINS.indexOf(plugin.name) === -1) {
      plugin.install(app, Launcher, ops)

      REGISTERED_PLUGINS.push(plugin.name)
    }

    this.plugin = plugin

    this.app = app
    this.Launcher = Launcher
    this.ops = ops
  }

  create() {
    if (!this.plugin.create) { // eslint-disable-line
      return null
    }

    return this.plugin.create.call(this.plugin, this.app, this.Launcher, this.ops) // eslint-disable-line
  }
}

export function installPlugin(app, Launcher, ops, plugin = {}) { // eslint-disable-line
  const pluginName = plugin.name
  const pluginInstall = plugin.install

  if (!pluginName || typeof pluginInstall !== 'function') {
    return
  }

  return new LauncherPlugin({ // eslint-disable-line
    app, Launcher, ops,
  }, plugin)
}

export function clearCachedPlugins() {
  REGISTERED_PLUGINS = []
}
